function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#ff4f8b;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-CloudWatch_Alarm_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M14.69,44.75H5.31a1,1,0,0,1-1-1V23.12a1,1,0,0,1,1-1h9.38a1,1,0,0,1,1,1V43.75A1,1,0,0,1,14.69,44.75Zm-8.38-2h7.38V24.12H6.31Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M29.69,44.75H20.31a1,1,0,0,1-1-1V27.81a1,1,0,0,1,1-1h9.38a1,1,0,0,1,1,1V43.75A1,1,0,0,1,29.69,44.75Zm-8.38-2h7.38V28.81H21.31Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 1.56,
  y: 46.5,
  width: 46.87,
  height: 2
}), React.createElement("path", {
  className: "cls-2",
  d: "M40,16.62a7.56,7.56,0,1,1,7.56-7.56A7.57,7.57,0,0,1,40,16.62ZM40,3.5a5.56,5.56,0,1,0,5.56,5.56A5.57,5.57,0,0,0,40,3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M44.69,44.75H35.31a1,1,0,0,1-1-1V18.89a1,1,0,0,1,.47-.85,1,1,0,0,1,1-.05,10,10,0,0,0,8.52,0,1,1,0,0,1,1,.05,1,1,0,0,1,.47.85V43.75A1,1,0,0,1,44.69,44.75Zm-8.38-2h7.38V20.36a11.93,11.93,0,0,1-7.38,0Z"
}));

var SvgAwsCloudWatchLogGroup = function SvgAwsCloudWatchLogGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsCloudWatchLogGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-CloudWatch_Log_Group.b4b26ec7.svg";
export { ForwardRef as ReactComponent };